@use "variables" as *;

.box {
  display: flex;
  border-radius: 12px !important;
  flex-shrink: 0;
}

.title {
  font-size: $fontSize-m;
  font-weight: bold;
  text-transform: none !important;
  padding-left: $spacing-s;
  padding-right: $spacing-s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
